import React from 'react';
import {connect} from 'react-redux';
import ContratoForm from '../gnp-registro-seguridad/contrato-medios.frm';
import { authentication } from '../app-database';
import { aceptoContrato } from './services.act';

import { goTo } from '../tools';

const mapState = (state) => {
	return {
		uid: state.login.uid,
		email: state.login.correo,
		pass: state.login.contrasena,
	};
};

const mapDispatch = (dispatch) => {
	return {
        loader: (show) => {
            dispatch({"type": "LOADER", "show": show});
        },
		aceptoContrato: (uid,email,pass) => {
		    dispatch(aceptoContrato(uid,email,pass));
		},
		resetPaso: () => {
			dispatch({ "type": "LOGIN_RESET_PASO" });
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje": sMensaje });
		}
	}
}

class Contrato extends React.Component{

	submit = (data) => {
		this.props.loader(true);
		if(data.acepto == true) {
		    let $this = this;
		    console.log("uid: "+this.props.uid+" email: "+this.props.email+" pass: "+this.props.pass);
		    aceptoContrato(this.props.uid,this.props.email,this.props.pass).then((response) => response.json()).then((responseJson) => {
            	if(responseJson.hasOwnProperty('jwt')){
	                    authentication.signOut().then(function() {
	                        console.log('Signed Out');
	                        authentication.signInWithCustomToken(responseJson.jwt).then(function(result) {
	                            // console.log(result);
	                            localStorage.setItem('refreshToken', responseJson.refreshtoken);
	                            
	                             goTo("home");
	                             
	                        }).catch(function(error) {
	                            console.log("signInWithCustomToken", error);
	                            $this.props.loader(false);
	                        });
	                    }, function(error) {
	                        console.error('Sign Out Error', error);
	                    });
	            } else {
	                this.props.alerta("Hubo un error al Loguearse. Favor de intentar más tarde.");
	            }	
    		 });
		} else {
		    this.props.resetPaso();
			goTo("login");
		}
	}

	render() {
		return <ContratoForm onSubmit={this.submit} />;
	}

}

export default connect(mapState, mapDispatch)(Contrato);


// WEBPACK FOOTER //
// ./src/gnp-login/contrato.cmpt.js